let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJdPv")).then(() => parcelRequire('6we9R'));